/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";
import { type FC } from "react";
import { theme } from "../../styles/theme/theme";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const AuthenticationLoading: FC = () => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
      gap: ${theme.spacing.md};
      background-color: ${theme.colors.background};
    `}
  >
    <div
      css={css`
        width: 36px;
        height: 36px;
        border: 3px solid ${theme.colors.border};
        border-top-color: ${theme.colors.primary};
        border-radius: 50%;
        animation: ${spin} 1s linear infinite;
      `}
    />
    <span
      css={css`
        font-size: ${theme.typography.fontSize.sm};
        color: ${theme.colors.mutedForeground};
      `}
    >
      Signing in…
    </span>
  </div>
);
